import { render, staticRenderFns } from "./DeleteAbsenceModal.vue?vue&type=template&id=6ae3374f&scoped=true"
import script from "./DeleteAbsenceModal.vue?vue&type=script&lang=js"
export * from "./DeleteAbsenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3374f",
  null
  
)

export default component.exports